import { render, staticRenderFns } from "./TransferSchedulesTable.vue?vue&type=template&id=74dd4b40&scoped=true"
import script from "./TransferSchedulesTable.vue?vue&type=script&lang=ts"
export * from "./TransferSchedulesTable.vue?vue&type=script&lang=ts"
import style0 from "./TransferSchedulesTable.vue?vue&type=style&index=0&id=74dd4b40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74dd4b40",
  null
  
)

export default component.exports